import { doGet } from './Base';


const getUser = async () => {
  return await doGet('/user');
};


export default getUser;
